module.exports = __webpack_public_path__ + "img/popup_cyber_wow_2025.873a59e5.jpg";